import _ from 'lodash';
import moment from 'moment';

import JsonapiClient from '@holidayextras/jsonapi-client';

import { configureRollbarUser, reportError } from '../../utils/error-handling-service';
import { identifyUser } from '../../utils/metric-analytics-service';
import { UPDATE_USER, CLEAR_USER } from './constants';
import { authService } from '../../utils/auth-service';
import ThemeSelector from '../../themes/theme-selector';
import {
  ORGANISATION_RESOURCE,
} from '../../utils/helpers/resources';

export function updateUser(userData) {
  const { disableIntercom } = ThemeSelector.theme();

  const extractedUserData = {
    id: userData.app_metadata ? userData.app_metadata.dyzio.u_id : '',
    organisationId: userData.app_metadata ? userData.app_metadata.dyzio.o_id : '',
    auth0_id: userData.user_id,
    email: userData.email || _.get(userData, 'app_metadata.dyzio.email', null),
    name: userData.name || _.get(userData, 'app_metadata.dyzio.name', null),
    version: userData.app_metadata.dyzio.version,
    nickname: userData.nickname,
    picture: userData.picture,
    role: userData.app_metadata ? userData.app_metadata.dyzio.role : 'blah',
  };

  const jsonAPIClient = new JsonapiClient(process.env.REACT_APP_API_BASE_URL, {
    header: {
      Authorization: `Bearer ${authService.getToken()}`,
    },
  });

  const intercomName = extractedUserData.name;
  const emailIdentifier = '@';

  const isNameEmailAddress = _.includes(intercomName, emailIdentifier);
  const { hostname } = window.location;
  // check the created date here?
  // version the users?
  jsonAPIClient.get(ORGANISATION_RESOURCE, extractedUserData.organisationId).then(organisationResource => {
    const organisation = organisationResource.toJSON();
    const userDto = {
      app_id: 'xef2tjr2',
      name: isNameEmailAddress ? '' : intercomName,
      email: extractedUserData.email,
      user_id: extractedUserData.id,
      apples: 10,
      hostname,
      role: extractedUserData.role,
      company: {
        id: extractedUserData.organisationId,
        name: organisation.name,
        plan: organisation.licenseSubscriptionType,
        monthly_spend: organisation.licenseSubscriptionAmount,
        org_type: organisation.orgType,
        remote_created_at: moment(organisation.createdDate).unix(),
      },
    };

    const pickedUserDto = _.pickBy(userDto);

    const { mixpanel } = window;
    if (mixpanel) {
      mixpanel.identify(extractedUserData.id);
      mixpanel.people.set({
        $email: extractedUserData.email,
        name: extractedUserData.name,
        role: extractedUserData.role,
        organisationId: extractedUserData.organisationId,
      });
    }

    window.dataLayer = window.dataLayer || [];
    const dataLayerInfo = {
      visitorStatus: 'logged-in',
      registeredDays: moment().diff(organisation.createdDate, 'days'),
      activityScore: organisation.activityScore,
      userId: userDto.user_id,
      companyName: userDto.company.name,
    };

    window.dataLayer.push(dataLayerInfo);

    if (extractedUserData.version > 1) {
      pickedUserDto.user_id = extractedUserData.id;
    }
    if (!disableIntercom) {
      window.Intercom('boot', pickedUserDto);
    }
    return true;
  }).catch(err => {
    reportError('ERROR_FETCHING_ORG_FOR_ROLLBAR', err);
  });

  const trackUserData = {
    id: userData.app_metadata ? userData.app_metadata.dyzio.u_id : '',
    email: userData.email,
    username: userData.name,
  };

  configureRollbarUser(trackUserData);
  // configureAppcuesUser(trackUserData);
  identifyUser(trackUserData);

  return {
    type: UPDATE_USER,
    user: extractedUserData,
  };
}

export function clearUser() {
  return {
    type: CLEAR_USER,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/user-widget/actions.js
 **/